"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isChildRegistered;

function isChildRegistered(childRef, activeChildren) {
  return activeChildren.findIndex(function (child) {
    return child.ref === childRef;
  }) !== -1;
}